var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const getAPIEndpoint = () => {
    const { location: { hostname: HOST_NAME = "" } = {} } = window || {};
    const DEV_URL = "https://execsmart.azurewebsites.net/";
    const QA_URL = "https://execsmarttestapi.azurewebsites.net/";
    // const Local_URL = "https://localhost:44329/"
    const URLS = {
        // localhost: Local_URL, //Local
        localhost: QA_URL,
        "execsmartui.azurewebsites.net": DEV_URL,
        "execsmarttestui.azurewebsites.net": QA_URL,
        "execsmart.org": DEV_URL //PROD
    };
    return URLS[HOST_NAME] || DEV_URL;
};
//# sourceMappingURL=env.js.map